import actions from './actions';
import mutations from './mutations';
import state from './initialState';

const brands = {
  namespaced: true,

  state,

  mutations,

  actions,
};

export default brands;
